/**
 * MINERVA CUSTOM CART — AJAX Controller
 * 
 * Bypasses Dawn's Section Rendering entirely.
 * Uses /cart/change.js with surgical DOM updates.
 * Updates: line prices, total, cart icon bubble, quantity values.
 */
(function () {
    'use strict';

    const cartContainer = document.getElementById('MinervaCart');
    if (!cartContainer) return;

    /* ─── Money Formatter ─── */
    function formatMoney(cents) {
        // Use the shop's money_format injected via Liquid
        const format = window.Shopify && window.Shopify.moneyFormat
            ? window.Shopify.moneyFormat
            : '€{{amount}}';

        const amount = (cents / 100).toFixed(2);
        const amountNoDecimals = Math.floor(cents / 100).toString();
        const amountWithComma = amount.replace('.', ',');

        return format
            .replace('{{amount_with_comma_separator}}', amountWithComma.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
            .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
            .replace('{{amount_no_decimals}}', amountNoDecimals)
            .replace('{{amount}}', amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
    }

    /* ─── Cart Icon Bubble Update ─── */
    function updateCartBubble(itemCount) {
        fetch(window.location.pathname + '?section_id=cart-icon-bubble')
            .then(function (r) { return r.text(); })
            .then(function (html) {
                var parsed = new DOMParser().parseFromString(html, 'text/html');
                var newBubble = parsed.querySelector('.shopify-section');
                var oldBubble = document.getElementById('cart-icon-bubble');
                if (newBubble && oldBubble) {
                    oldBubble.innerHTML = newBubble.innerHTML;
                }
            })
            .catch(function () { /* silently fail — non-critical */ });
    }

    /* ─── AJAX Cart Update ─── */
    function updateCart(key, quantity) {
        var itemRow = document.getElementById('CartItem-' + key);

        // Immediate visual feedback for removal
        if (quantity === 0 && itemRow) {
            itemRow.style.transition = 'opacity 0.3s ease, max-height 0.4s ease';
            itemRow.style.opacity = '0.3';
            itemRow.style.pointerEvents = 'none';
        }

        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id: key, quantity: quantity })
        })
            .then(function (response) { return response.json(); })
            .then(function (cart) {

                // --- REMOVAL ---
                if (quantity === 0) {
                    if (itemRow) {
                        // Also remove the <hr> divider after it
                        var divider = itemRow.nextElementSibling;
                        if (divider && divider.classList.contains('mc-divider')) {
                            divider.remove();
                        }
                        itemRow.remove();
                    }

                    // If cart is now empty, show empty state without page reload
                    if (cart.item_count === 0) {
                        var form = document.getElementById('mc-cart-form');
                        if (form) form.remove();

                        // Hide the footer section (totals, buttons)
                        var footerSection = document.getElementById('main-cart-footer');
                        if (footerSection) footerSection.style.display = 'none';

                        // Inject the empty state with fade-in
                        cartContainer.querySelector('.page-width').insertAdjacentHTML(
                            'beforeend',
                            '<div class="mc-empty-state" style="animation: fadeIn 0.4s ease;"><p>YOUR CART IS EMPTY</p></div>'
                        );
                        return;
                    }
                }

                // --- QUANTITY CHANGE ---
                if (quantity > 0) {
                    var updatedItem = cart.items.find(function (i) { return i.key === key; });
                    if (updatedItem) {
                        // Update all price nodes for this line item (mobile + desktop)
                        var priceNodes = document.querySelectorAll('.mc-line-price[data-key="' + key + '"]');
                        priceNodes.forEach(function (node) {
                            node.textContent = formatMoney(updatedItem.final_line_price);
                        });

                        // Sync displayed quantity with server (in case of stock limits)
                        var qtyNode = document.getElementById('Qty-' + key);
                        if (qtyNode) {
                            qtyNode.textContent = updatedItem.quantity;
                        }
                    }
                }

                // --- UPDATE GLOBAL TOTAL ---
                var totalNode = document.getElementById('CartTotal');
                if (totalNode) {
                    totalNode.textContent = formatMoney(cart.total_price);
                }

                // --- UPDATE CART ICON BUBBLE ---
                updateCartBubble(cart.item_count);

                // --- PUBLISH EVENT (for cart drawer compatibility) ---
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'minerva-cart', cartData: cart });
                }
            })
            .catch(function (error) {
                console.error('[Minerva Cart] API Error:', error);
                // Revert visual state on error
                if (itemRow) {
                    itemRow.style.opacity = '1';
                    itemRow.style.pointerEvents = '';
                }
            });
    }

    /* ─── Event Delegation ─── */
    cartContainer.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;

        // ＋ / − Quantity
        if (btn.classList.contains('mc-qty-btn')) {
            e.preventDefault();
            var key = btn.dataset.key;
            var qtyNode = document.getElementById('Qty-' + key);
            var currentQty = parseInt(qtyNode.textContent, 10);

            var newQty;
            if (btn.classList.contains('mc-qty-plus')) {
                newQty = currentQty + 1;
            } else {
                newQty = currentQty - 1;
            }

            if (newQty < 0) return;

            // Optimistic UI: update number immediately
            qtyNode.textContent = newQty;

            if (newQty === 0) {
                // Treat as removal
                updateCart(key, 0);
            } else {
                updateCart(key, newQty);
            }
        }

        // ✕ Remove
        if (btn.classList.contains('mc-remove-btn')) {
            e.preventDefault();
            updateCart(btn.dataset.key, 0);
        }
    });

    /* ─── Terms & Conditions Checkbox ─── */
    var termsCheckbox = document.getElementById('minerva-terms-checkbox');
    var checkoutBtn = document.getElementById('checkout');

    if (termsCheckbox && checkoutBtn) {
        // Sync on load (in case of browser back button)
        checkoutBtn.disabled = !termsCheckbox.checked;

        termsCheckbox.addEventListener('change', function () {
            checkoutBtn.disabled = !termsCheckbox.checked;
        });
    }
})();
